module.exports = __webpack_public_path__ + "static/screenshot2-062d8faa903eaa9a59c2ef33f480b632.png";